module.exports = "https://pearup-project-assets.s3.eu-central-1.amazonaws.com/scratch/assets/f546923e2c2d53c58bbfcb56caefcd42.png";